__turbopack_context__.v({
  "content": "EmailNotConfirmedOverlay-module-scss-module__KmUW3q__content",
  "logoutButton": "EmailNotConfirmedOverlay-module-scss-module__KmUW3q__logoutButton",
  "message": "EmailNotConfirmedOverlay-module-scss-module__KmUW3q__message",
});
